import { useCallback, useEffect, useState } from 'react';
export const useMediaQuery = (query)=>{
    const getMatches = (queryTemp)=>{
        // Prevents SSR issues
        if (typeof window !== 'undefined') {
            return window.matchMedia(queryTemp).matches;
        }
        return false;
    };
    const [matches, setMatches] = useState(getMatches(query));
    const handleChange = useCallback(()=>{
        setMatches(getMatches(query));
    }, [
        query
    ]);
    useEffect(()=>{
        const matchMedia = window.matchMedia(query);
        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        if (typeof matchMedia.addEventListener === 'function') {
            matchMedia.addEventListener('change', handleChange);
        }
        return ()=>{
            if (typeof matchMedia.removeEventListener === 'function') {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [
        handleChange,
        query
    ]);
    return matches;
};
export const useIsResponsive = ()=>useMediaQuery('(max-width: 486px)');
export const useIsTablet = ()=>useMediaQuery('(max-width: 768px)');
export const useIsLargeSizeTablet = ()=>useMediaQuery('(min-width: 1025px) and (max-width: 1280px)');
export const useIsMediumSizeTablet = ()=>useMediaQuery('(min-width: 769px) and (max-width: 1024px)');
